import React, { useEffect, useState } from "react"
import moment from 'moment';
import comercioService from "../../hacienda/actividadEconomica/service/comercio.service";
import { Dimmer } from "../../spinner";
import { formatMoneda } from "../../../util/varios";
export default function Menu(props) {

    const post = JSON.parse(localStorage.getItem('post'));
    const fechasistema = JSON.parse(localStorage.getItem('fechasistema'));
    const efiscaldes = localStorage.getItem('efiscaldes');
    const nominasel = localStorage.getItem('titulonomina');
    const [usuario, setUsuario] = useState('');
    const [nomOrg, setNomOrg] = useState('');
    const [mostrar, setMostrar] = useState(false);
    const factorCambio = JSON.parse(localStorage.getItem('factorCambio'))
    const [activate, setActivate] = useState(false);
    
    useEffect(() => {
        let obj = JSON.parse(localStorage.getItem('post'));

        if (obj != null) {

            setUsuario(obj.login);
            setNomOrg(obj.nombreorg);

        } else {

            setUsuario('');
            setNomOrg('');

        }

    }, []);
    return (
        <div>
            {/* ACTION BUTTON */}
            <nav className='col-12 m-0 px-4 py-2 azulGradiant text-light shadow d-flex align-items-center justify-content-center gap-4' style={{ minHeight: '6dvh' }}>
    <button className="bg-transparent border-0 d-flex align-items-center p-0 m-0 position-absolute left-0 mx-4"
        type="button"
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasExample"
        aria-controls="offcanvasExample">
        <i className='fa fa-bars text-light fs-4' />
    </button>

    {props.llamado === 1 ?
        <h2 className='p-0 pl-4 m-0 text-center fs-5 fw-bold'>
            {'Sistema de Nomina [' + post.nombreorg + '] [ La Nomina Actual es: ' + nominasel + ']'}
        </h2>
        :
        <h2 className='p-0 pl-4 m-0 text-center fs-5 fw-bold'>
            {post.nombreorg + '(' + efiscaldes + ')'}
        </h2>}

    {/* Contenedor para usuario y fecha a la derecha */}
    <div className="d-flex align-items-center gap-3 ms-auto">
        <label className="my-auto fw-bold text-uppercase" style={{ color: "#ffffff" }}>
            Valor Euro €: {formatMoneda(
              factorCambio?.valor?.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2
            )}
        </label>
        <label className="my-auto fw-bold" style={{ color: "#ffffff" }}>
            <i className="far fa-calendar-alt"> {moment.utc(fechasistema).format('DD/MM/YYYY')}</i>
        </label>

        <label className="my-auto" style={{ color: "#ffffff" }}>
            <i className="fas fa-user-tie"> {usuario}</i>
        </label>
    </div>
</nav>

            {/* SIDE MENU */}
            <div style={{ width: '300px' }} className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
                {/* MENU HEADER CONTENT */}
                <div className="d-flex flex-column postition-relative w-100 m-0 p-2 align-items-center">
                    <img src={props.op.imagenes + '/imagen?img=' + props.op.logologin}
                        style={{ width: "100px" }}
                        alt="" />
                    <h5 className="m-0 second-text">
                        {moment.utc(fechasistema).format("DD-MM-YYYY")}
                    </h5>
                    <button type="button"
                        className="btn-close position-absolute top-0 right-0 mt-2 mr-2"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close">
                    </button>
                </div>
                {/* MENU MAIN CONTENT */}
                <div className="offcanvas-body">
                    <div className='d-flex flex-column position-relative list-group list-group-flush my-3 z-0'>
                        <button type="button" onClick={props.show} className="btn H btn-sm btn-primary fw-bold fs-5"> <i className="fas fa-tachometer-alt me-2"></i>Opensiap</button>
                        {props.children}
                    </div>
                </div>
            </div>
                  <Dimmer active={activate} inverted />
            
        </div>
        
    )
}